export default "__VITE_ASSET__BNFaGw8F__"